// STRATURILE INSTALAȚIILOR din meniul vizualizatorului: câte o categorie
// (Apă, Ventilație, Electrice, Incendiu) care se aprinde întreagă, cu
// subcategoriile ei dedesubt — apă rece, apă caldă, canalizare, pluviale,
// încălzire —, fiecare cu pastila ei de culoare, aceeași din desen. Aceleași
// butoane (`meniu-comutator`, `dv-swatch`, `viewer.css`) ca restul straturilor.

import { useT } from "../i18n";
import { useInstalatii } from "./context";
import { CATEGORII, CULOARE, SISTEME, type Sistem } from "./model";
import "./instalatii.css";

export default function StraturiInstalatii() {
  const t = useT();
  const inst = useInstalatii();
  if (!inst) return null;
  const numar = new Map<Sistem, number>();
  for (const s of inst.model?.segmente ?? []) numar.set(s.sistem, (numar.get(s.sistem) ?? 0) + 1);
  const numeSistem = (s: Sistem) => t(SISTEME.find((x) => x.sistem === s)!.nume);
  return (
    <div className="meniu-comutatoare inst-straturi">
      {CATEGORII.map((c) => {
        const aprinse = c.sisteme.filter((s) => inst.vizibile.has(s)).length;
        const toate = aprinse === c.sisteme.length;
        return (
          <div key={c.categorie} className="inst-categorie">
            <button className={`meniu-comutator${aprinse ? " on" : ""}${aprinse && !toate ? " partial" : ""}`}
                    aria-pressed={toate ? true : aprinse ? "mixed" : false}
                    title={t(toate ? "inst.strat.stinge" : "inst.strat.aprinde", { ce: t(c.nume) })}
                    onClick={() => inst.comuta(c.sisteme, !toate)}>
              <span className="inst-pastile" aria-hidden="true">
                {c.sisteme.map((s) => <i key={s} style={{ background: CULOARE[s] }} />)}
              </span>
              <span className="meniu-comutator-nume">{t(c.nume)}</span>
            </button>
            {c.sisteme.length > 1 && (
              <div className="inst-subcategorii">
                {c.sisteme.map((s) => {
                  const on = inst.vizibile.has(s);
                  const n = numar.get(s) ?? 0;
                  return (
                    <button key={s} className={`meniu-comutator${on ? " on" : ""}`} aria-pressed={on}
                            title={t(on ? "inst.strat.stinge" : "inst.strat.aprinde", { ce: numeSistem(s) })}
                            onClick={() => inst.comuta([s], !on)}>
                      <span className="dv-swatch" aria-hidden="true" style={{ background: CULOARE[s] }} />
                      <span className="meniu-comutator-nume">{numeSistem(s)}</span>
                      {inst.model && <span className="meniu-comutator-nr">{n}</span>}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
